import React, { useState } from "react";
import { APP_SERVICES_URL } from "../../Constant/constant";
import axios from "axios";
import userSession from "../../Constant/auth";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import "../../CSS/ManualInput.css";
import { Modal } from "react-bootstrap";
import moment from "moment";
import "../../Pages/HomePage.css";

const ManualInputModal = ({
  selectedOptions,
  setCameraData,
  cameraData,
  setManualInputSuccess,
  show,
  onHide,
}) => {
  const { CustID, authHeader, site } = userSession;
  const [updateOcrValue, setUpdateOcrValue] = useState("");
  // eslint-disable-next-line
  const [response, setResponse] = useState(false);
  function getLocalTimezoneISO() {
    // Get the current date and time in the local time zone
    const localTime = moment();

    // Format the date in ISO 8601 format with the local time zone offset
    const localTimeWithOffset = localTime.format("YYYY-MM-DDTHH:mm:ss.SSS");

    return localTimeWithOffset;
  }
  
  const handleSubmit = async (updateOcrValue) => {
    // Check if the given value after trim is blank, null, or undefined
    if (!updateOcrValue || updateOcrValue.trim() === "") {
      NotificationManager.error(
        <div className="showNormalFont">
          Please enter a valid license number
        </div>,
        <div className="showNormalFont">Error</div>,
        3000
      );
      return; // Exit the function early if value is blank, null, or undefined
    }
    const formattedOcrValue = updateOcrValue.replace(/\s/g, "").toUpperCase();
    const apiUrl = `${APP_SERVICES_URL}/sn-events-service/${CustID}/event?getAlertInfo=true`;
    // Generate current timestamp
    const localTimezoneISO = getLocalTimezoneISO();
    const requestBody = {
      rule: "Manual Input",
      ocr: formattedOcrValue,
      pumpName: selectedOptions.pumpName,
      siteName: site.name,
      created: localTimezoneISO,
    };
    try {
      setResponse(false);
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          Authorization: authHeader,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const { left: eventId, right: offenceType } = JSON.parse(response.data);

        // Request was successful, handle response data if needed
        // Update the `ocr` field for all elements where `pumpName` matches
          const eventAddedTime = moment.utc().toISOString();  // <-- Add this line (use moment.js here)

        const updatedCameraData = cameraData.map((camera) => {
          if (camera.pumpName === selectedOptions.pumpName) {
            return {
              ...camera,
              eventID: eventId,
              ocr: formattedOcrValue,
              previousOffenceType: offenceType || undefined,
              eventTime: localTimezoneISO,
              eventAddedTime: eventAddedTime,
            };
          } else {
            return camera;
          }
        });
        setManualInputSuccess(true);
        setCameraData(updatedCameraData);
        setResponse(true);
        setUpdateOcrValue("");
        onHide();
      } else {
        setResponse(false);
        setManualInputSuccess(false);
      }
    } catch (error) {
      // Handle any network errors or Axios errors
      console.error("Network error:", error);
      setManualInputSuccess(false);
    }
  };

  const handleUpdatePlateClick = () => {
    // Call your function here and pass the OCR value as an argument
    handleSubmit(updateOcrValue);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <div style={{ borderRadius: "10px" }}>
        <div className=" manual-input-modal">
          <div className="modal-header">
            <h5
              className="modal-title manual-input-heading"
              id="fullscreenModalLabel"
              style={{ color: "#fff" }}
            >
              MANUAL INPUT
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onHide}
            ></button>
          </div>
          <div className="fluid-container">
            <div className="container">
            <input
              type="text"
              autoComplete="off"
              className="form-control mt-2 showNormalFont "
              id="manual-input-box"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-lg"
              value={updateOcrValue}
              onChange={(e) => setUpdateOcrValue(e.target.value)} // Update the OCR value in state
              placeholder="Licence Number"
              required
              maxLength={10}
              onInput={(e) => {
                // Remove non-alphanumeric characters and spaces
                let sanitizedValue = e.target.value.replace(
                  /[^a-zA-Z0-9]/g,
                  ""
                );

                // Update the input value
                e.target.value = sanitizedValue.toUpperCase();

                // Update the state with the sanitized value
                setUpdateOcrValue(sanitizedValue);
              }}
            />
            </div>
            <div className="container d-flex manual-input-btns showNormalFont">
              <button
                type="button"
                className="btn btn-modal"
                data-bs-dismiss={response ? "modal" : ""}
                onClick={handleUpdatePlateClick} // Call the function on button click>
                style={{ width: "fit-content" }}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-modal"
                style={{ width: "fit-content" }}
                onClick={onHide}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManualInputModal;
